import React from 'react';
import { Redirect } from 'react-router-dom';
import { FuseUtils } from '@fuse/index';
import { ExampleConfig } from 'main/content/example/ExampleConfig';
import { LoginConfig } from '../main/content/login/LoginConfig';
import { CompanyConfig } from '../main/content/company/CompanyConfig';
import { SettlementConfig } from '../main/content/settlement/SettlementConfig';
import { BrokerConfig } from '../main/content/brokersettlement/BrokerSettlementConfig';
import { CustodianConfig } from '../main/content/custodian/CustodianConfig';
import { BrokerRecConfig } from '../main/content/broker_rec/BrokerRecConfig';
import { isinApplicationsConfig } from "../main/content/isinApplications/isinApplicationsConfig";
import {FileRequestUploadConfig} from "../main/content/fileRequest/FileRequestUploadConfig";
import {FileRequestConfig} from "../main/content/fileRequest/FileRequestConfig";

const routeConfigs = [
  ExampleConfig,
  LoginConfig,
  CompanyConfig,
  BrokerConfig,
  SettlementConfig,
  CustodianConfig,
  BrokerRecConfig,
  isinApplicationsConfig,
  FileRequestUploadConfig,
  FileRequestConfig
];

export const routes = [
  ...FuseUtils.generateRoutesFromConfigs(routeConfigs),
  {
    path: '/',
    component: () => <Redirect to="/dashboard" />
  }
];



// WEBPACK FOOTER //
// ./src/fuse-configs/fuseRoutesConfig.js